/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'save': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.6 11v3.8h6.8V11a.4.4 0 00-.4-.4H5a.4.4 0 00-.4.4zm8 3.8V11A1.6 1.6 0 0011 9.4H5A1.6 1.6 0 003.4 11v3.8H2a.8.8 0 01-.8-.8V2a.8.8 0 01.8-.8h2.9v1.5a1.4 1.4 0 001.4 1.4h3.4a1.4 1.4 0 001.4-1.4V1.2h.98a.8.8 0 01.607.28l1.92 2.24a.8.8 0 01.193.52V14a.8.8 0 01-.8.8h-1.4zM9.9 1.2H6.1v1.5c0 .11.09.2.2.2h3.4a.2.2 0 00.2-.2V1.2zM0 14V2a2 2 0 012-2h10.08A2 2 0 0113.6.698l1.92 2.24A2 2 0 0116 4.24V14a2 2 0 01-2 2H2a2 2 0 01-2-2z" _fill="#01B9CA"/>'
  }
})
